function genHiddenScrollContainer() {
  // Creating invisible container
  const el = document.createElement('div');
  el.style.visibility = 'hidden';
  el.style.overflow = 'scroll'; // forcing scrollbar to appear
  el.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(el);

  function clearElement() {
    el.parentNode.removeChild(el);
  }
  clearElement.element = el;

  return clearElement;

  // Removing temporary elements from the DOM
}

export default function getScrollbarWidth(element) {
  let clearElement, width;
  if (element == null || element === document.body) {
    // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript?noredirect=1&lq=1#comment89665801_40568748
    clearElement = genHiddenScrollContainer();
    element = clearElement.element;
  } else if (!(element instanceof HTMLElement))
    throw Error('getScrollbarWidth: Not an HTML Element');

  width = element.offsetWidth - element.clientWidth;

  if (clearElement) clearElement();

  return width;
}
